import { ContributionVEFStatus, isResultSuccess, } from '../types';
class ContributionsVEFService {
    contributionsVEFAdapter;
    contributionsVEFFormatter;
    storeService;
    /**
     * Contributions VEF Service.
     *
     */
    constructor({ contributionsVEFAdapter, contributionsVEFFormatter, storeService }) {
        this.contributionsVEFAdapter = contributionsVEFAdapter;
        this.contributionsVEFFormatter = contributionsVEFFormatter;
        this.storeService = storeService;
    }
    async getContributionsVEFCount() {
        await this.loadTotalFormationNotStartedContributionsVEF();
        await this.loadTotalFormationAlreadyStartedContributionsVEF();
        const totalFormationNotStartedContributionsVEFStore = this.storeService
            .getTotalFormationNotStartedContributionsVEF()
            .data();
        const totalFormationAlreadyStartedContributionsVEFStore = this.storeService
            .getTotalFormationAlreadyStartedContributionsVEF()
            .data();
        const totalContributionsVEF = totalFormationNotStartedContributionsVEFStore + totalFormationAlreadyStartedContributionsVEFStore;
        return totalContributionsVEF;
    }
    checkContributionVEF(reference, data) {
        return this.contributionsVEFAdapter.check(reference, data);
    }
    validateContributionVEF(data) {
        return this.contributionsVEFAdapter.validate(data);
    }
    /**
     * Loads the list of contributions VEF from the adapter service.
     *
     * @param pagination - An object containing the "from" and "size" properties for pagination.
     * @param filters - Optional filters to apply on the list of contributions VEF.
     * @param contributionsVEFStore - contributionsVEFStore
     * @param totalContributionsVEFStore - totalContributionsVEFStore
     * @param aggregationsContributionsVEFStore - aggregationsContributionsVEFStore
     * @returns A promise that resolves when the list of contributions VEF has been loaded.
     */
    async loadContributionsVEF(pagination, filters, contributionsVEFStore, totalFilteredContributionsVEFStore, aggregationsContributionsVEFStore) {
        if (!contributionsVEFStore.loading()) {
            contributionsVEFStore.SET_LOADING(true);
            try {
                const contributionsVEF = await this.contributionsVEFAdapter.searchContributionsVEF(pagination, Object.keys(aggregationsContributionsVEFStore.data()).length === 0, filters);
                if (isResultSuccess(contributionsVEF)) {
                    const formatted = await this.contributionsVEFFormatter.formatContributionsVEFList(contributionsVEF.response.data);
                    contributionsVEFStore.SET_DATA(formatted);
                }
                else {
                    contributionsVEFStore.SET_DATA([]);
                }
                totalFilteredContributionsVEFStore.SET_DATA((isResultSuccess(contributionsVEF) && contributionsVEF.response.meta?.total) || 0);
                if (isResultSuccess(contributionsVEF) && Object.keys(contributionsVEF.response.aggregations).length > 0) {
                    aggregationsContributionsVEFStore.SET_DATA(contributionsVEF.response.aggregations);
                }
            }
            catch (error) {
                contributionsVEFStore.SET_ERROR(error);
            }
            contributionsVEFStore.SET_LOADING(false);
        }
    }
    async loadFormationNotStartedContributionsVEF(pagination, filters) {
        const formationNotStartedContributionsVEFStore = this.storeService.getFormationNotStartedContributionsVEF();
        const totalFilteredFormationNotStartedContributionsVEFStore = this.storeService.getTotalFilteredFormationNotStartedContributionsVEF();
        const aggregationsFormationNotStartedContributionsVEFStore = this.storeService.getFormationNotStartedAggregationsContributionsVEF();
        filters.contributionVEFStatus = ContributionVEFStatus.REQUESTED;
        filters.formationDateStarted = false;
        filters.cloture = false;
        await this.loadContributionsVEF(pagination, filters, formationNotStartedContributionsVEFStore, totalFilteredFormationNotStartedContributionsVEFStore, aggregationsFormationNotStartedContributionsVEFStore);
    }
    async loadFormationAlreadyStartedContributionsVEF(pagination, filters) {
        const formationAlreadyStartedContributionsVEFStore = this.storeService.getFormationAlreadyStartedContributionsVEF();
        const totalFilteredFormationAlreadyStartedContributionsVEFStore = this.storeService.getTotalFilteredFormationAlreadyStartedContributionsVEF();
        const aggregationsFormationAlreadyStartedContributionsVEFStore = this.storeService.getFormationAlreadyStartedAggregationsContributionsVEF();
        filters.contributionVEFStatus = [ContributionVEFStatus.REQUESTED, ContributionVEFStatus.CHECKED];
        filters.formationDateStarted = true;
        filters.cloture = false;
        await this.loadContributionsVEF(pagination, filters, formationAlreadyStartedContributionsVEFStore, totalFilteredFormationAlreadyStartedContributionsVEFStore, aggregationsFormationAlreadyStartedContributionsVEFStore);
    }
    async loadTotalContributionsVEF(filters, totalContributionsVEFStore) {
        // If the store module is not already loading data
        if (!totalContributionsVEFStore.loading()) {
            // Set the store module to loading mode
            totalContributionsVEFStore.SET_LOADING(true);
            try {
                // Call the adapter service and wait for the response
                const payload = await this.contributionsVEFAdapter.countContributionsVEF(filters);
                // Set the response data on the store module
                totalContributionsVEFStore.SET_DATA((isResultSuccess(payload) && payload.response) || 0);
            }
            catch (error) {
                // Set the error on the store module
                totalContributionsVEFStore.SET_ERROR(error);
            }
            // Set the store module to not loading mode
            totalContributionsVEFStore.SET_LOADING(false);
        }
    }
    /**
     * Loads the count of requestion contributions VEF from the adapter service.
     */
    async loadTotalFormationNotStartedContributionsVEF(filters = {}) {
        const totalFormationNotStartedContributionsVEFStore = this.storeService.getTotalFormationNotStartedContributionsVEF();
        filters.contributionVEFStatus = ContributionVEFStatus.REQUESTED;
        filters.formationDateStarted = false;
        filters.cloture = false;
        await this.loadTotalContributionsVEF(filters, totalFormationNotStartedContributionsVEFStore);
    }
    /**
     * Loads the count of requestion contributions VEF from the adapter service.
     */
    async loadTotalFormationAlreadyStartedContributionsVEF(filters = {}) {
        const totalFormationAlreadyStartedContributionsVEFStore = this.storeService.getTotalFormationAlreadyStartedContributionsVEF();
        filters.contributionVEFStatus = [ContributionVEFStatus.REQUESTED, ContributionVEFStatus.CHECKED];
        filters.formationDateStarted = true;
        filters.cloture = false;
        await this.loadTotalContributionsVEF(filters, totalFormationAlreadyStartedContributionsVEFStore);
    }
}
export { ContributionsVEFService };
//# sourceMappingURL=contributions-vef-service.js.map